export default __webpack_public_path__ + "static/media/isotype_doyo.19aefa91.svg";